// extracted by mini-css-extract-plugin
export default {"textDecorationNone":"textDecorationNone__zH5so"};